<template>
    <div class="row pt-3" style="border-top: 1px dashed rgba(106, 113, 133, 0.3);">
        <div class=" col-sm-12">
            <label>
                <h6 class="f-w-700">{{ t('PromotionPeriodDateRange') }}</h6>
            </label>
        </div>
        <div class="col-sm-6">
            <div class="mb-3">
                <label>
                    <h6 class="f-w-700">{{ t('StartDate') }}</h6>
                </label>
                <input class="form-control digits" type="date" v-model="compState.startDate">
            </div>
        </div>
        <div class="col-sm-6">
            <div class="mb-3">
                <label>
                    <h6 class="f-w-700">{{ t('EndDate') }}</h6>
                </label>
                <input class="form-control digits" type="date" v-model="compState.endDate">
            </div>
        </div>
        <div class=" col-sm-12 mt-3">
            <label>
                <h6 class="f-w-700">{{ t('PromotionPeriodTimeOfDay') }}</h6>
            </label>
        </div>
        <div class="col-sm-6">
            <div class="mb-3">
                <label>
                    <h6 class="f-w-700">{{ t('StartTime') }}</h6>
                </label>
                <input class="form-control digits" type="time" v-model="compState.startTime">
            </div>
        </div>
        <div class="col-sm-6">
            <div class="mb-3">
                <label>
                    <h6 class="f-w-700">{{ t('EndTime') }}</h6>
                </label>
                <input class="form-control digits" type="time" v-model="compState.endTime">
            </div>
        </div>
        <h6 class="f-w-700 my-3 col-12">{{ t('DaysOfWeek') }}</h6>
        <div class="custom-scrollbar list-container px-3 nav-link" style=" height: 290px;">
            <div class=" text-center text-dark rounded-3 hover-pointer card mb-0 d-flex flex-column justify-content-center align-items-center gap-2"
                @click="onDayClick(item.id)"
                :style="{ boxShadow: findIsSelectedDay(item.id) ? 'inset 0 0 16px rgba(0, 0, 0, 0.7)' : 'none' }"
                style="grid-column: span 1 / span 1; height: 112px; user-select: none;" v-for="item in DaysMock">
                <h5>{{ t(item.name) }}</h5>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { computed, reactive, watch, onMounted } from 'vue'
import { usePromotionStore } from '@/store/management/promotionStore';
import type { Promotion } from '@/store/management/promotionStore';

import { useI18n } from 'vue-i18n'
import { promotionTimeControlLanguage } from '@/core/locales/promotions-language';

const { t } = useI18n({
  messages: promotionTimeControlLanguage
})

const promotionStore = usePromotionStore()
const DaysMock = [
    { id: '1', name: 'Sunday' },
    { id: '2', name: 'Monday' },
    { id: '3', name: 'Tuesday' },
    { id: '4', name: 'Wednesday' },
    { id: '5', name: 'Thursday' },
    { id: '6', name: 'Friday' },
    { id: '7', name: 'Saturday' },
]
const compState = reactive({
    startDate: '',
    endDate: '',
    startTime: '',
    endTime: '',
    daysOfWeek: [] as string[]
})

const activePromotion = computed(() => {
    return promotionStore.getActivePromotion
})

const tempActivePromotion = computed(() => {
    return promotionStore.getActivePromotion
})

const activePromotionId = computed(() => {
    return promotionStore.getActivePromotion.basic.id
})

const findIsSelectedDay = (id: string) => {
    return compState.daysOfWeek.includes(id)
}

const onDayClick = (id: string) => {
    if (compState.daysOfWeek.includes(id)) {
        compState.daysOfWeek = compState.daysOfWeek.filter(day => day !== id)
    } else {
        compState.daysOfWeek.push(id)
    }
}

onMounted(() => {
    if (tempActivePromotion.value?.basic.id) {
        compState.startDate = tempActivePromotion.value.timeControl.startDate
        compState.endDate = tempActivePromotion.value.timeControl.endDate
        compState.startTime = tempActivePromotion.value.timeControl.startTime
        compState.endTime = tempActivePromotion.value.timeControl.endTime
        compState.daysOfWeek = tempActivePromotion.value.timeControl.daysOfWeek
    }
})

watch(activePromotionId, (newVal) => {
    if (newVal) {
        const promotion = activePromotion.value
        compState.startDate = promotion.timeControl.startDate
        compState.endDate = promotion.timeControl.endDate
        compState.startTime = promotion.timeControl.startTime
        compState.endTime = promotion.timeControl.endTime
        compState.daysOfWeek = promotion.timeControl.daysOfWeek
    }
}, { immediate: true });

watch(compState, (newVal) => {
    promotionStore.setActivePromotion({
        ...tempActivePromotion.value,
        timeControl: {
            startDate: newVal.startDate,
            endDate: newVal.endDate,
            startTime: newVal.startTime,
            endTime: newVal.endTime,
            daysOfWeek: newVal.daysOfWeek
        }
    } as Promotion)
}, { deep: true });

</script>

<style scoped lang="scss">
.destination-container {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 1rem;
}

.hover-pointer {
    cursor: pointer;
}

.nav-link {
    color: var(--bs-heading-color);
}
</style>